import * as Actions from '../../actions';

const initialState = { data: null };

const listRoutesReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_ROUTES_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listRoutesReducer;
